import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BrandListResponse, Brand } from './brands.types';
import { RouteParamsType } from '../../types/utils/router-params.type';
import { rejectWithApiError } from '../../utils/api';
import { RootReducerState } from '../../redux/Reducers';

export const getBrandsList = createAsyncThunk('brands/getBrandsList', async (params: RouteParamsType, thunkAPI) => {
  try {
    const response = await axios.get<BrandListResponse>(`${process.env.REACT_APP_API_URL}/brands`, {
      params,
    });
    return response.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error, fallback: 'Error fetching brands list!' });
  }
});

export const getBrandDetails = createAsyncThunk<Brand, number, { state: RootReducerState; rejectValue: string }>(
  'brands/getBrandDetails',
  async (id, thunkAPI) => {
    try {
      const response = await axios.get<Brand>(`${process.env.REACT_APP_API_URL}/brands/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithApiError({ thunkAPI, error, fallback: 'Error fetching brand details!' });
    }
  }
);

export const createBrand = createAsyncThunk('brands/createBrand', async (data: { name: string }, thunkAPI) => {
  try {
    const response = await axios.post<Brand>(`${process.env.REACT_APP_API_URL}/brands`, data);
    return response.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error, fallback: 'Error creating brand!' });
  }
});

export const updateBrand = createAsyncThunk(
  'brands/updateBrand',
  async ({ id, data }: { id: number; data: { name: string } }, thunkAPI) => {
    try {
      const response = await axios.put<Brand>(`${process.env.REACT_APP_API_URL}/brands/${id}`, data);
      return response.data;
    } catch (error) {
      return rejectWithApiError({ thunkAPI, error, fallback: 'Error updating brand!' });
    }
  }
);

export const deleteBrandDetails = createAsyncThunk<
  Brand,
  { id: number; fetchList?: boolean },
  { state: RootReducerState }
>('brands/deleteBrandDetails', async ({ id, fetchList = false }: { id: number; fetchList?: boolean }, thunkAPI) => {
  try {
    const response = await axios.delete(`${process.env.REACT_APP_API_URL}/brands/${id}`);
    await new Promise(resolve => setTimeout(resolve, 1000));
    if (fetchList) {
      thunkAPI.dispatch(getBrandsList(thunkAPI.getState().brandsReducer.brandsRouteParams));
    }
    return response.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error, fallback: 'Error deleting brand!' });
  }
});
